// extracted by mini-css-extract-plugin
export default {"text":"ToolTipButton_text__QAszy","tooltipContent":"ToolTipButton_tooltipContent__1+Lxe"};